module.exports = __webpack_public_path__ + "media/flags/bl-64d62940.svg";